import axios from 'axios';
import { getEnv } from '../config';

export class APIError extends Error {
  constructor(status, message) {
    super(message);
    this.name = 'APIError';
    this.status = status;
  }
}

const api = axios.create({
  baseURL: getEnv("REACT_APP_API_URL"),
  withCredentials: true,
});

export const apiUsers = {

  async getUsers() {
    try {
      const response = await api.get('/users');
      return response.data.usuarios;
    } catch (error) {
      
      if (error.isAxiosError) {
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  },

  async checkUser() {
    try {
      const response = await api.get('/users/check-user');
      return response.data;
    } catch (error) {
      
      if (error.isAxiosError) {
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  },

  async createUser(data) {
    try {
      const response = await api.post('/users/create-user', data);
      
      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  },

  async updateUser(id, data) {
    try {
      
      const response = await api.put(`/users/edit/${id}`, data);
      
      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response?.status === 404) {
          throw new APIError(404, `User with id ${id} not found`);
        }
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  },

  async deleteUser(id) {
    try {
      await api.put(`/users/deactivate/${id}`);
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response?.status === 404) {
          throw new APIError(404, `Profile with id ${id} not found`);
        }
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  },
};

export default apiUsers;

